module.exports = __webpack_public_path__ + "img/trial-primary.87ed2fdb.svg";